"use strict";

exports.registerServiceWorker = function () {
  return true;
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-offline/gatsby-browser.js
// module id = 436
// module chunks = 231608221292675